/* eslint-disable react/react-in-jsx-scope */
import { useAuth } from "@/auth/hooks/useAuth";
import ImpersonationBanner from "@/dashboard/components/layout/ImpersonationBanner";
import Navigation from "@/components/layout/Navigation";
import { FC, ReactNode, useEffect } from "react";
import { useSession } from "@/broadcastChannel/useSession";
import { useNavigate } from "react-router-dom";

const LayoutSubmit: FC<{ children: ReactNode }> = ({ children }) => {
  const { session } = useSession();
  const { user } = useAuth();
  const showAdminSubcontractorBanner =
    typeof window !== "undefined" &&
    localStorage.getItem("isImpersonating") === "true" &&
    user?.roles?.includes("ROLE_SUBCONTRACTOR");
    useEffect(() => {
        const isSubcontractor = localStorage.getItem("isSubcontractor");
        const slugName = localStorage.getItem("slugName");
        const link = localStorage.getItem("link");
        if (!session && isSubcontractor && slugName && link) {
          const url = `/authentification-cfp/${link}/${slugName}`;
          window.location.href = url;
        } else if(!session && !isSubcontractor && !slugName && !link) {
            window.location.href = `/login`;
        }
      }, [session]);
  
  return (
    <div id="container-main" className="relative">
      <ImpersonationBanner visible={Boolean(showAdminSubcontractorBanner)} />
      <Navigation />
      {children}
    </div>
  );
};

export default LayoutSubmit;
